// Parses the display name out of an RFC 5322 "From" header. The header is
// untrusted; callers must render the result as text, never markup.
export const senderDisplayName = (from: string): string => {
  const angle = from.indexOf("<");
  if (angle <= 0) return from.trim();
  return from.slice(0, angle).trim().replace(/^"|"$/g, "") || from.trim();
};
